// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// import reportWebVitals from "./reportWebVitals";
// import { createBrowserHistory } from "history";
// import { Router, Switch, Route } from "react-router-dom";
// import { publicRoutes, privateRoutes } from './routes/Routes';
// import PublicRoute from './routes/PublicRoute';
// import PrivateRoute from './routes/PrivateRoute';
// import "antd/dist/antd.css";
// import NotFound from "./views/NotFound";
// const hist = createBrowserHistory();

// ReactDOM.render(
//   <Router history={hist}>
//     <Switch>

//       {publicRoutes.map((prop, key) => {
//         return <PublicRoute exact path={prop.path} component={prop.component} key={key} />;
//       })}

//       {privateRoutes.map((prop, key) => {
//         return <PrivateRoute exact path={prop.path} component={prop.component} key={key} />;
//       })}
//       <Route component={NotFound} />
//     </Switch>
//   </Router>,
//   document.getElementById("root")
// );

// reportWebVitals();

import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserHistory } from "history";
import { Router, Switch, Route } from "react-router-dom";
import { publicRoutes, privateRoutes } from "./routes/Routes";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import "antd/dist/antd.css";
import NotFound from "./views/NotFound";

const hist = createBrowserHistory();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Router history={hist}>
    <Switch>
      {publicRoutes.map((prop, key) => (
        <PublicRoute exact path={prop.path} component={prop.component} key={key} />
      ))}

      {privateRoutes.map((prop, key) => (
        <PrivateRoute exact path={prop.path} component={prop.component} key={key} />
      ))}

      <Route component={NotFound} />
    </Switch>
  </Router>
);

reportWebVitals();
